import { render, staticRenderFns } from "./PriceDetailInfo.vue?vue&type=template&id=4b6286fd&scoped=true"
import script from "./PriceDetailInfo.vue?vue&type=script&lang=js"
export * from "./PriceDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./PriceDetailInfo.vue?vue&type=style&index=0&id=4b6286fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6286fd",
  null
  
)

export default component.exports